import { useEffect, useState } from "react";
import TabContext from "@mui/lab/TabContext";
import { Grid } from "@mui/material";
import Tab from "@mui/material/Tab";
import Table from "../../../components/Table/Table";
import SubmittedImg from "../../../assets/images/submittedimg.svg";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { toast } from "react-toastify";
import PageTitle from "../../../components/PageTitle";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
import Badge from "../../../components/Badge";
// import Button from "../../../components/Button";
import NoExamFound from "../../../assets/images/noexam.svg";
import AssignmentCard from "../components/AssignmentCard";
// import StudentTestCard from "../../../pages/test/components/StudentTestCard";
import { TableSearch } from "../../../components/Table/TableActions";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";
import Layout from "../../../components/Layout";
import useWindowSize from "../../../hooks/useWindow";

const STUDENT_ASSIGNMENT = "/api/v1/student/assignment";

const StudentAssignment = () => {
  const classes = useStyles();
  // const [value, setValue] = useState("");
  const [submittedModal, setSubmittedModal] = useState(false);
  const [noExamModal, setNoExamModal] = useState(false);
  const [exams, setExams] = useState([]);
  const [assignmentSearchResult, setAssignmentSearchResult] = useState([]);
  const [assignmentResult, setAssignmentResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("1");
  const width = useWindowSize();
  const mobile = width < 600;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const columns = [
    {
      name: "Subject Name",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject Name</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Created By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created By</p>}
          {`${row?.created_by?.last_name || "--/--"} ${row?.created_by?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Class Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Class Name</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Is CA",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Is CA</p>}
          {row?.is_ca ? "YES" : "--/--"}
        </>
      )
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Status</p>}
          {<Badge status={row?.status} />}
        </>
      )
    },
    {
      name: "Student Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Score</p>}
          {row?.student_score || "0"}
        </>
      )
    },
    {
      name: "Total Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total Score</p>}
          {row?.total_grade || "--/--"}
        </>
      )
    }
  ];

  const handleSearchAssignmentByClass = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = assignmentResult?.filter((data) => valArray?.every(
      (word) => data?.created_by?.last_name
        ?.toLowerCase()
        .includes(word?.toLowerCase()) ||
      data?.created_by?.first_name
        ?.toLowerCase()
        .includes(word?.toLowerCase()) ||
      data?.subject?.name
        ?.toLowerCase()
        .includes(word?.toLowerCase())
    )
    );
    setAssignmentSearchResult(result);
  };

  const handleSubmittedModal = () => {
    setSubmittedModal(!submittedModal);
  };

  // get all Applicant Exam
  const getStudentAssignment = () => {
    setIsLoading(true);
    httprequest.get(STUDENT_ASSIGNMENT).then((res) => {
      setExams(res?.data?.data?.filter((submitted) => submitted?.status?.toLowerCase() !== "submitted"));
      setAssignmentResult(res?.data?.data?.filter((submitted) => submitted?.status?.toLowerCase() === "submitted"));
      setAssignmentSearchResult(res?.data?.data?.filter((submitted) => submitted?.status?.toLowerCase() === "submitted"));
      setIsLoading(false);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err.response.data);
    });
  };

  useEffect(() => {
    getStudentAssignment();
  }, []);

  const handleNoExamModal = () => {
    setNoExamModal(!noExamModal);
  };

  return (
    <Layout children={
      <div className={`${classes.border} page-content`}>
        <PageTitle
          title="All Assignment accessible to you"
          subtitle="These are all the assignmnet you can take"
          // button={
          //   <div className="flex gap-10">
          //     <Button onClick={handleNoExamModal} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Check for Exam" />
          //   </div>
          // }
        />
        <div className="page-content height-full">
          <TabContext value={value}>
            <div className="tablist-container padding-left-16">
              <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
                <Tab label="My Assignments" value="1" />
                <Tab label="My Assignment Results" value="2" />
              </Tabs>
            </div>
            <TabPanel value="1" className="tabpanel-overide">
              <Grid container sx={{ marginTop: "3px" }} spacing={2}>
                {isLoading ? (
                  <div className="padding-top-56 margin-auto">
                    <PageLoader />
                  </div>
                ) : (
                  <>
                    {exams && exams.length > 0 ? (
                      exams.map((an_assignment, index) => {
                        // const exam_id = exam?.exam_id || exam?.subject?.id;

                        return (
                          <Grid item lg={4} md={6} sm={12} xs={12} key={index}>
                            <AssignmentCard
                              testtitle={an_assignment?.subject?.name}
                              testdesc={an_assignment?.description || "Attempt this Assignment"}
                              // duration={`${an_assignment?.duration || "0"}`}
                              testlink={`/student-assignment/${an_assignment?.id}`}
                            />
                          </Grid>
                        );
                      })
                    ) : (
                      <div className={classes.noexamcont}>
                        <div className={classes.noexamimg}>
                          <img src={NoExamFound} alt="Not Found" />
                        </div>
                        <div>
                          <p className={classes.nocodeheader}>No Assignment Found</p>
                          <p className={classes.nocodesentence}>No has not uploaded any assignment for you to see.</p>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Grid>
            </TabPanel>
            <TabPanel sx={{ padding: "0px !important" }} value="2">
              <Table data={assignmentSearchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
                <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignmentByClass} />
              }
              />
            </TabPanel>
          </TabContext>

          {/* <ToastContainer /> */}
          {/* <div className="pagination-container">
            <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} variant="outlined" shape="rounded" color="primary" />
          </div> */}
        </div>
        {/* Exam Submitted MOdal */}
        <Modal
          title="Great Job"
          subtitle=""
          modalContent={
            <>
              <div>
                <div className={classes.forerrorimg}>
                  <img src={SubmittedImg} alt="Submitted Image" />
                </div>
                <div>
                  <p className={classes.nocodeheader}>Your Assignment has been submitted</p>
                  <p className={classes.nocodesentence}>Go to the result section to see your result</p>
                </div>
              </div>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={submittedModal}
          closeModal={handleSubmittedModal}
        />
        {/* No Exam Found MOdal */}
        <Modal
          title="Check For Your Assignment"
          subtitle=""
          modalContent={
            <>
              <div>
                <div className={classes.noexamimg}>
                  <img src={NoExamFound} alt="Not Found" />
                </div>
                <div>
                  <p className={classes.nocodeheader}>No Assignment Found</p>
                  <p className={classes.nocodesentence}>The school admin has not uploaded any assignment for you to see.</p>
                </div>
              </div>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={noExamModal}
          closeModal={handleNoExamModal}
        />
      </div>
    }
    />
  );
};

export default StudentAssignment;
